import {
  NetworkActivityTimeframeType,
  NetworkTopThreadStarterSenderFilter,
  ThreadExtendedActivityFilter,
  ThreadExtendedActivityTimeframeType,
  TopNetworkAnnouncementSortOrder,
  TopNetworkGroupSortOrder,
  TopNetworkThemeThreadSortOrder,
  TopNetworkThreadSortOrder,
  ViewerActivityThreadType,
  ViewerActivityTimeframeType,
  ViewerTopThreadType,
} from '@ms/yammer-graphql';

import { create } from '../createOverridableMock';

import { AnalyticsSettings } from './types';

export const defaultAnalyticsSettings: AnalyticsSettings = {
  selectedOnBehalfOfUserId: undefined,
  networkActivitySettings: {
    timeframe: NetworkActivityTimeframeType.TWENTY_EIGHT_DAYS,
    topThreadStarterSenderFilter: NetworkTopThreadStarterSenderFilter.ALL_USERS,
    topNetworkAnnouncementSortOrder: TopNetworkAnnouncementSortOrder.VIEW_COUNT_DESC,
    topNetworkGroupSortOrder: TopNetworkGroupSortOrder.POST_COUNT_DESC,
    topNetworkThemeThreadSortOrder: TopNetworkThemeThreadSortOrder.VIEW_COUNT_DESC,
    topNetworkThreadSortOrder: TopNetworkThreadSortOrder.VIEW_COUNT_DESC,
  },
  threadExtendedActivitySettingsForOthers: {
    timeframe: ThreadExtendedActivityTimeframeType.TWENTY_EIGHT_DAYS,
    includePlatformActivity: false,
    filterEntityId: undefined,
    filterBy: ThreadExtendedActivityFilter.NONE,
  },
  threadExtendedActivitySettingsForStorylineAnnouncement: {
    timeframe: ThreadExtendedActivityTimeframeType.TWENTY_EIGHT_DAYS,
    includePlatformActivity: true,
    filterEntityId: undefined,
    filterBy: ThreadExtendedActivityFilter.NONE,
  },
  threadExtendedActivitySettingsForCommunityAnnouncement: {
    timeframe: ThreadExtendedActivityTimeframeType.TWENTY_EIGHT_DAYS,
    includePlatformActivity: true,
    filterEntityId: undefined,
    filterBy: ThreadExtendedActivityFilter.NONE,
  },
  viewerActivitySettings: {
    timeframe: ViewerActivityTimeframeType.TWENTY_EIGHT_DAYS,
    threadType: ViewerActivityThreadType.ALL,
    topThreadType: ViewerTopThreadType.VIEWER_MOST_VIEWED_THREADS,
  },
};

export const createMockAnalyticsSettings = create<AnalyticsSettings>(defaultAnalyticsSettings);
